/**
 * Icon wrapper. The design system says: Lucide only, 1.5px stroke, decorative
 * icons inherit the text colour. Going through this component is how the stroke
 * width stays 1.5 everywhere — a raw `<CircleAlert />` would render at Lucide's
 * default 2px.
 */
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export const ICON_STROKE = 1.5

interface IconProps {
  icon: LucideIcon
  className?: string
  /** Set only when the icon carries meaning no adjacent text carries. */
  label?: string
}

export function Icon({ icon: Glyph, className, label }: IconProps) {
  return (
    <Glyph
      strokeWidth={ICON_STROKE}
      className={cn('size-4 shrink-0', className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  )
}
